import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Slide from '@material-ui/core/Slide';
import Button from './Button.jsx';

import './basic_dialog.scss';

class BasicDialog extends Component {
  render() {
    const {
      open, onClose, children, title,
    } = this.props;

    return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="basicDialog"
        open={open}
        /* onClose={onClose} */
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
          className: 'basicDialogBackdrop',
        }}
      >
        <Slide direction="up" in={open} mountOnEnter unmountOnExit>
          <div className="basicDialogWindow">
            <div className="basicDialogWindow_title">
              {title}
            </div>
            <div className="basicDialogWindow_content">
              {children}
            </div>
            <div className="basicDialogWindow_actions">
              <Button onClick={onClose} color="primary">Okay</Button>
            </div>
          </div>
        </Slide>
      </Modal>
    );
  }
}

BasicDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
};

export default BasicDialog;
